import * as Types from './navActionTypes.js'

const initialState = {
    smart: "PRODUCTION",
    showActiveLines: false,
    showActiveRecyclingLines: false,
    currentURL: "/",
};

export default function nav(state = initialState, action) {
    switch (action.type) {
        case Types.SET_SMART:
            if (state.smart !== action.smart) {
                return Object.assign({}, state, { smart: action.smart });
            }
            return state;
        case Types.SET_SHOWACTIVELINES:
            if (state.showActiveLines !== action.showActiveLines) {
                return Object.assign({}, state, { showActiveLines: action.showActiveLines });
            }
            return state;
        case Types.SET_SHOWACTIVERECYCLINGLINES:
            if (state.showActiveRecyclingLines !== action.showActiveRecyclingLines) {
                return Object.assign({}, state, { showActiveRecyclingLines: action.showActiveRecyclingLines });
            }
            return state;
        case Types.SET_CURRENTURL:
            if (state.currentURL !== action.currentURL) {
                return Object.assign({}, state, { currentURL: action.currentURL });
            }
            return state;   
        default:
            return state;
    }
}